import {APIv1} from "../../api";

export const updateUserData = async ({data, companyInn, token}) => {
    const requestBody = {
        name: data.companyName,
        user_email: data.email,
        address: data.address,
        phone_number: data.phone,
        click: data.click,
        pay_me: data.payme,
        apelsin: data.uzum,
        anor: data.anor,
        send_sms: data.isSendSms,
        scan2pay_theme: data.s2pTheme,
        is_scan2pay_tip: data.isS2pTip,
        scan2pay_default_tip_percent: data.s2pDefaultTipPercent,
    };

    try {
        const response = await APIv1.put(`/company/profile/update/${companyInn}/`,
            requestBody,
            {
                headers: {
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json'
                }
            });

        return response?.data.status === "successfully";
    } catch (err) {
        console.error("Error updating user data:", err);
        return false;
    }
};
